import Config from './conf';

/**
 * Converts an integer (0-11) to an abbreviated month string
 */
const monthToString = function (monthInt) {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul',
    'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return months[monthInt];
};

/**
 * Accepts hours (0 to 23) and minutes (0 or 30) and converts it into a 12-hour AM/PM display string.
 */
const toDisplay = function(hours, minutes) {
  let meridian = 'AM';
  if (hours >= 12) {
    meridian = 'PM';
    if (hours > 12) {
      hours -= 12;
    }
  }
  if (minutes === 0) {
    minutes = '00';
  }
  return hours + ':' + minutes + ' ' + meridian;
};

/**
 * Converts a string such as "5:30 PM" to hours and minutes (17, 30).
 */
const toHoursMinutes = function(str) {
  const splitted = str.split(' ');
  const meridian = splitted[1];
  const hoursMins = splitted[0].split(':');
  let hours = Number(hoursMins[0]);
  if (meridian === 'PM' && hours !== 12) {
    hours += 12;
  }
  const mins = Number(hoursMins[1]);
  return {
    hours,
    mins
  };
};


/**
 * Converts a string to title case (eg. front right photo -> Front Right Photo)
 * @todo replace all instances of formatName to  toTitleCase (same functionality)
 * @param {String} str
 * @return {String}
 */
function toTitleCase(str) {
  return str.replace(/\w*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
}

/**
 * GETs a resource from the backend. If the server responds with 401 Forbidden,
 * it means the path requires authorization and we didn't supply a valid token,
 * and this method will redirect us to the login page.
 *
 * @TODO stop sending token via query param
 */
const backendGet = function (path, token, params, logout) {
  let url = Config.BACKEND_API_URL + path;

  // add token/params if applicable
  if (!params)
    params = [];

  if (token)
    params.push('token=' + token);

  // add params to url
  url += '?' + params.join('&');

  return new Promise((resolve, reject) => {
    fetch(url, {method: 'get'}).then((res) => {
      if (res.status === Config.TOKEN_REQUIRED) {
        // redirect to login page
        reject(false);
        return;
      }
      res.json().then((json) => {
        resolve(json);
      });
    }).catch((err) => {
      console.log('An unknown backendGet() error occurred:', err.toString());
      if (err.toString() === 'TypeMismatchError' || err.toString().indexOf('TypeError') !== -1) {
        reject(false);
      } else {
        reject(err);
      }
    });
  });
};

/**
 * POSTs a resource to the backend. If the server responds with 401 Forbidden,
 * it means the path requires authorization and we didn't supply a valid token,
 * and this method will redirect us to the login page.
 */
const backendPost = function (path, body, token) {
  let url = Config.BACKEND_API_URL + path;
  // add token if applicable
  if (token)
    url += '?token=' + token;

  return new Promise((resolve, reject) => {
    fetch(url, {
      method: 'post',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }).then((res) => {
      if (res.status === Config.TOKEN_REQUIRED) {
        reject(false); // redirect to login page
      }
      res.json().then((json) => {
        resolve(json);
      });
    }).catch((err) => {
      console.log('An unknown backendPost() error occurred:', err);
      if (err.toString() === 'TypeMismatchError' || err.toString().indexOf('TypeError') !== -1) {
        reject(false);
      } else {
        reject(err);
      }
    });
  });
};

export default {
  monthToString,
  toDisplay,
  toHoursMinutes,
  backendGet,
  backendPost,
  toTitleCase,
};



// WEBPACK FOOTER //
// ./src/app/Util.js